import { ChakraProvider } from '@chakra-ui/react';
import CandidateInterviewHeader from '@/components/CandidateInterviewHeader';
import InterviewEnding from '@/components/InterviewEnding';
import PreScreeningWelcoming from '@/components/PreScreeningWelcoming';
import SendConfirmationModal from '@/components/SendConfirmationModal';
import WelcomingInterviewContainer from '@/components/WelcomingInterviewContainer';
import { chakraExtendedTheme } from '@/styles/theme';
import { CandidateInterviewPageStages } from '@/types';
import { InterviewTypes } from '@/utils/interviews';
import SubmittingPreScreening from '../SubmittingPreScreening';

type InterviewQuestionType = {
  label: string;
  id: string;
};

type CandidatePreScreeningInterviewType = {
  isSubmitting?: boolean;
  questions: InterviewQuestionType[];
  onChangeInterviewState: (state: CandidateInterviewPageStages) => void;
  onSubmitAnswers: (answers: any) => void;
  interviewState: CandidateInterviewPageStages;
  alertState: boolean;
  candidateName: string;
  onConfirmSubmitAnswers: () => void;
  onCancelSubmitting: () => void;
};

export default function CandidatePreScreeningInterviewComponent({
  candidateName,
  isSubmitting,
  questions,
  onChangeInterviewState,
  onSubmitAnswers,
  interviewState,
  alertState,
  onConfirmSubmitAnswers,
  onCancelSubmitting,
}: CandidatePreScreeningInterviewType): JSX.Element {
  return (
    <ChakraProvider theme={chakraExtendedTheme}>
      <div id="dialog-container" />
      <div>
        <CandidateInterviewHeader
          candidateName={candidateName}
          interviewType={InterviewTypes.PRE_SCREENING}
          interviewState={interviewState}
        />

        {interviewState === CandidateInterviewPageStages.WELCOME && (
          <WelcomingInterviewContainer
            firstName={candidateName.split(' ')[0]}
            interviewType={InterviewTypes.PRE_SCREENING}
            onClickNextStep={() => onChangeInterviewState(CandidateInterviewPageStages.SUBMIT)}
          >
            <PreScreeningWelcoming />
          </WelcomingInterviewContainer>
        )}

        {interviewState === CandidateInterviewPageStages.SUBMIT && (
          <SubmittingPreScreening questions={questions} onSubmitAnswers={onSubmitAnswers} />
        )}

        {interviewState === CandidateInterviewPageStages.ENDING && (
          <InterviewEnding interviewType={InterviewTypes.PRE_SCREENING} />
        )}

        <SendConfirmationModal
          isButtonDisabled={isSubmitting}
          isOpen={alertState}
          actionMessage="your answers to Pre-Screening will be sent to Trio. Make
              sure you’re all set before sending it."
          onClose={onCancelSubmitting}
          onConfirmHandler={onConfirmSubmitAnswers}
        />
      </div>
    </ChakraProvider>
  );
}
